/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolNutritionIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-nutrition"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 21.32Q12 21.32 10.47 21.32Q8.95 21.32 6.81 19.19Q4.67 17.05 4.67 14Q4.67 11.75 5.91 9.9Q7.15 8.05 9.25 7.2Q8.43 6.9 7.88 6.31Q7.33 5.72 6.97 4.95Q6.63 4.17 6.51 3.27Q6.4 2.38 6.47 1.48Q7.58 1.4 8.6 1.64Q9.63 1.88 10.45 2.4Q11.28 2.92 11.84 3.71Q12.4 4.5 12.53 5.53Q12.88 4.78 13.31 4.09Q13.75 3.4 14.32 2.83Q14.7 2.45 15.21 2.42Q15.72 2.4 16.13 2.75Q16.55 3.13 16.56 3.7Q16.57 4.28 16.18 4.67Q15.65 5.2 15.28 5.83Q14.9 6.45 14.68 7.17Q16.8 8 18.06 9.86Q19.32 11.72 19.32 14Q19.32 17.05 17.19 19.19Q15.05 21.32 12 21.32Z" fill={color} />
    </svg>
  );
}
